import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import clsx from "clsx";
import magic from "@/icons/magic.svg";
import { CategoryContent } from "@/typings/categoryContent";

function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("expanded");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?q=${encodeURIComponent(input)}`
  );
}

const Card = ({
  category,
  Icon,
  expanded = true,
  title,
  image,
  description = "",
  expandedDescription,
  searchTerm,
  dataReason,
  imagePriority,
  onSearchSubmit = () => {}
}: CategoryContent) => {
  
  const handleCardClick = () => {
    dispatchCustomEvent({
      dataObject: "body-inspoCard",
      dataType: "button",
      dataReason,
    });
    setURLParams(searchTerm);
    onSearchSubmit(true);
  };

  return (
    <div
      role="group"
      className={clsx(
        expanded
          ? "w-[90%] xs:w-full mx-auto p-[16px] max-w-[580px] sm:max-w-full min-h-[328px]"
          : "w-full h-[149px] xs:h-[168px] lg:h-[168px] ",
        "rounded-[8px] bg-white shadow-inspoCard flex grow relative animate-fadeIn z-10"
      )}
    >
      <div className={clsx(expanded && "flex-col xl:flex-row", "w-full flex")}>
        {expanded ? (
          <div className="w-[97%] rounded-[8px] mb-2 mx-auto">
            <div className="object-cover relative rounded-[8px] overflow-hidden">
              <img
                src={image}
                alt=""
                fetchpriority={imagePriority}
                className="rounded-[8px] w-full"
              />
              
            </div>
          </div>
        ) : (
          <img
            src={image}
            alt=""
            fetchpriority={imagePriority}
            className="rounded-[8px] w-[117px] h-[117px] xs:w-[136px] xs:h-[136px] m-[16px]"
          />
        )}
        <div
          className={clsx(
            expanded
              ? "h-[142px] sm:h-[154px] md:h-[149px] xl:h-[312px] ml-2"
              : "h-full",
            "w-full flex flex-col justify-between"
          )}
        >
          <div
            className={clsx(
              !expanded && "max-h-[120px]",
              "w-full text-charcoal flex flex-col flex-grow xl:flex-grow-0 justify-between "
            )}
          >
            <h2
              className={clsx(
                expanded
                  ? "max-w-[240px] xs:max-w-[280px] md:max-w-[372px] xl:mt-[96px] xl:mx-[8px] w-full xl:mb-[16px] flex-grow leading-[24px]"
                  : "mt-[24px] lg:mt-[32px] xl:mb-[8px] mx-[8px] leading-[20px]",
                "text-[16px] xs:text-[20px] line-clamp-2 "
              )}
            >
              <div dangerouslySetInnerHTML={{__html:title}}></div>
            </h2>
            <span
              className={clsx(
                expanded
                  ? "xl:mx-[8px] mb-[19px] xl:mb-[12px] flex-grow"
                  : "mb-[18px] mx-[8px] max-h-[18px] hidden xs:block gridCustom:hidden md:block flex-grow pt-2",
                "text-[14px] leading-[18px] sm:max-w-[372px] "
              )}
            >
              {expanded ? expandedDescription : description}
            </span>
          </div>
        </div>
      </div>

      <button
        className="absolute bottom-4 right-6 syfclickevent self-end bg-syfYellow uppercase font-bold py-[8px] px-[8px] rounded-[4px]  h-[32px] text-[12px] text-charcoal"
        onClick={handleCardClick}
        id={`search-this-example-${searchTerm.replaceAll(" ", "-")}`}
        data-object="body-inspoCard"
        data-type="button"
        data-reason={`${searchTerm.replaceAll(" ", "_")}-search_this_example`}
      >
        {searchPromptDetails?.promptSectionCTAText}
      </button>
      <img
        src={searchPromptDetails?.searchIcon}
        alt=""
        className={clsx(
          expanded
            ? "flex sm:hidden min-[820px]:flex absolute bottom-[136px] sm:bottom-[144px] right-6  xl:top-2 xl:right-4 opacity-[60%] xl:opacity-[80%]"
            : "top-2 right-4 opacity-[80%] relative",
          "h-[17px] lg:h-[20px]"
        )}
      />
      {category && Icon ? (
        <div
          className={clsx(
            expanded
              ? "bottom-6 xl:top-4 left-[24px] lg:left-[18px] xl:left-[330px] w-1/3 lg:w-1/2"
              : "hidden",
            "h-[17px] lg:h-[20px] absolute flex items-center gap-1 leading-[16px] text-[12px] text-charcoal"
          )}
        >
          <img src={Icon} className="h-[13px] w-[13px] filter contrast-50"/>  
          <span className="truncate">{category}</span>
        </div>
      ) : null}
    </div>
  );
};

export default Card;
